import { render, staticRenderFns } from "./PainelIcon.vue?vue&type=template&id=b28f17c4"
import script from "./PainelIcon.vue?vue&type=script&lang=js"
export * from "./PainelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports